import { AppSidebarLayout } from "../layouts";
import { AppListByOrg } from "../shared";

export const AppsPage = () => {
  return (
    <AppSidebarLayout>
      <AppListByOrg />
    </AppSidebarLayout>
  );
};
